import { error } from '@ms/yammer-telemetry/dist/logging';
import loadPolyfills from '@ms/yammer-web-polyfills';
const polyfillsLoader = async () => {
  try {
    await loadPolyfills();
  } catch (err: unknown) {
    error('Failed to polyfill:', err);
  }
};
export default polyfillsLoader;
